import { useState, useCallback } from "react";

export type MfaStep =
  | "mfa-selection" // @mfa-type.component.js
  | "setup-mfa-phone" // @setup-mfa-phone.component.js
  | "mfa-verification" // @submit-mfa.component.js
  | "mfa-timeout";

type UseMfaNavigationOptions = {
  initialStep?: MfaStep;
  initialBannerText?: string;
};

type UseMfaNavigationReturn = {
  step: MfaStep;
  bannerText: string;
  navigate: (step: MfaStep, updateBannerText: string) => void;
};

export function useMfaNavigation(options: UseMfaNavigationOptions = {}): UseMfaNavigationReturn {
  const bannerTextDefault = options.initialBannerText || "Multi-Factor Authentication";
  const [step, setStep] = useState<MfaStep>(options.initialStep || "mfa-selection");
  const [bannerText, setBannerText] = useState<string>(bannerTextDefault);

  const navigate = useCallback(
    (nextStep: MfaStep, updateBannerText: string = bannerTextDefault) => {
      setStep(nextStep);
      setBannerText(updateBannerText);
    },
    [bannerTextDefault]
  );

  return {
    step,
    bannerText,
    navigate,
  };
}
